import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  label: {
    marginLeft: theme.spacing(3),
    marginRight: theme.spacing(3),
  },
  root: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    width: '164px',
  },
  input: {
    textAlign: 'center',
    "-moz-appearance": "textfield",
    "&::-webkit-outer-spin-button": {
      "-webkit-appearance": "none",
    },
    "&::-webkit-inner-spin-button": {
      "-webkit-appearance": "none",
    }
  },
}));